export default __webpack_public_path__ + "static/media/image-highlight.afc5a2ba.jpg";